import { gkApi } from './index';

const backstageDeliveryApi = gkApi.injectEndpoints({
  endpoints: (builder) => ({
    // Latest persisted plan (drives the page on load / after a reload).
    getBackstageDeliveryPlan: builder.query({
      query: () => ({
        url: '/backstage-delivery/',
        method: 'get',
      }),
      providesTags: ['BACKSTAGE_DELIVERY_PLAN'],
    }),
    // Upload the two CSV exports as multipart; the body is a FormData, which
    // fetchBaseQuery forwards untouched (no JSON content-type) so the multipart
    // boundary is preserved.
    createBackstageDeliveryPlan: builder.mutation({
      query: (formData) => ({
        url: '/backstage-delivery/',
        method: 'post',
        body: formData,
      }),
      invalidatesTags: ['BACKSTAGE_DELIVERY_PLAN'],
    }),
  }),
});

export const {
  useGetBackstageDeliveryPlanQuery,
  useCreateBackstageDeliveryPlanMutation,
} = backstageDeliveryApi;
